import { createStyles } from 'antd-style'

import { useSiderMenuStore } from '@eastcoal/router/components/SiderMenu/hooks/useStore'

const useStyles = createStyles(({ token }) => ({
  menu: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },
  item: {
    flex: 1,
    borderRadius: 'unset',
    [`&>a`]: {
      display: 'block',
      height: 40,
      lineHeight: '40px',
      fontSize: token.fontSizeHeading5,
      color: token.colorText,
      fontWeight: token.fontWeightStrong,
      textAlign: 'center',
      transition: 'all 0.3s',
      borderTopLeftRadius: token.borderRadiusXS,
      borderTopRightRadius: token.borderRadiusXS
    },
    [`&:hover>a`]: {
      color: token.colorPrimaryText
    },
    [`&.is-selected>a`]: {
      color: token.colorWhite,
      backgroundColor: token.colorPrimary,
      [`&:hover`]: {
        backgroundColor: token.colorPrimaryHover
      }
    }
  }
}))

export const NavbarMenu = () => {
  const { menus, selectedKeys } = useSiderMenuStore()
  const { cx, styles } = useStyles()

  return (
    <ul className={styles.menu}>
      {menus.map(({ key, label }) => (
        <li
          key={key}
          role='menuitem'
          className={cx(styles.item, {
            ['is-selected']: selectedKeys.includes(key)
          })}
        >
          {label}
        </li>
      ))}
    </ul>
  )
}
